<template>
  <div type="card-full">
    <!-- <div slot="header" class="header">
      <el-button type='primary' @click="lodopPrint" :loading="btnLoading">打印</el-button>
      <slot></slot>
    </div> -->
    <div class="other-content" id="px" ref="px">
      <div class="title">
        {{ model.pjnoticetitle }}
      </div>
      <!-- <div class="desc">
        <div>采购人:{{model.comfullname}}</div>
        <div>项目编号:{{model.projectcode}}</div>
      </div> -->
      <!-- <div class="line"></div> -->
      <div class="line1"></div>
      <div class="content" style="margin-top: 5px">
        <div v-html="model.pjnoticedesc" class="content"></div>
      </div>
      <div class="line1" v-if="model.pjnoticedesc"></div>
      <div v-if="model.appendList && model.appendList.length" class="filelist">
        <div
          v-for="(item, index) in model.appendList"
          :key="index"
          class="fileitem"
        >
          <div class="name" @click="downFile(item.appendurl)">
            <a :src="uploadAddr + item.appendurl">{{ item.appendfilename }}</a>
          </div>
        </div>
      </div>
      <div class="value" v-if="+model.pjnoticetype !== 60">
        <div>发布时间：{{ model.pjnoticetime | newDate }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getLodop } from "@/assets/js/LodopFuncs";
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import dayjs from "dayjs";
import common from "@/mixin/common";
let LODOP;
export default {
  name: "pjothernotice",
  mixins: [common],
  data() {
    return {
      type: this.$route.params.type,
      pjnoticeid: this.$route.query.pjnoticeid,
      btnLoading: false,
      model: {},
    };
  },
  created() {
    this.init();
    this.getModel();
  },
  filters: {
    newDate(value) {
      return value ? dayjs(value).format("YYYY-MM-DD") : "";
    },
    qfwVal(value) {
      return utils.comdify(value);
    },
  },
  mounted() {},
  watch: {
    noticeid() {
      this.init();
      this.getModel();
    },
  },
  methods: {
    async init() {
      this.btnLoading = false;
      this.model = {};
    },

    async getModel() {
      let cosid = this.$store.getters.loginUser.cosid
        ? this.$store.getters.loginUser.cosid
        : this.$store.getters.expertLoginUser.cosid;
      let res = await request({
        method: "get",
        url: "/xmgl/pjnotice/getPJNoticeListById",
        params: { pjnoticeid: this.$route.query.pjnoticeid, cosid: cosid },
      });
      this.model = res;
    },
    // close() {
    //   this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
    // },
    //   async lodopPrint () {
    //     LODOP = await getLodop()
    //     var style = document.createElement('link')
    //     style.href = 'http://120.78.91.121:9600/upload/20200806/1596702260371.css'
    //     style.rel = 'stylesheet'
    //     style.type = 'text/css'
    //     document.getElementById("px").appendChild(style)
    //     if (LODOP) {
    //       LODOP.SET_PRINT_STYLE("FontSize",10);
    //       LODOP.ADD_PRINT_HTM(	10, 0, "90%", "80%",document.getElementById("px").innerHTML);
    //       LODOP.PREVIEW();
    //     }
    //   }
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/table.scss";
.other-content {
  display: flex;
  flex-direction: column;
  // align-items: center;
  /*width: 100vw;*/
  /*height: 100vh;*/

  // overflow: auto;
  font-weight: bold;
  .title {
    text-align: center;
    font-size: 22px;
    color: #000;
    word-wrap: break-word;
    font-weight: bold;
  }
  .desc {
    display: flex;
    justify-content: space-between;
    color: #000;
    font-size: 14px;
    line-height: 18px;
    text-align: left;
    margin: 10px 0;
  }
  .line,
  .line1 {
    width: 100%;
    background: #000;
  }
  .line {
    height: 1px;
    margin-bottom: 4px;
  }
  .line1 {
    height: 1px;
  }
  .content {
    padding: 10px 20px;
    line-height: 28px;
  }
  .value {
    padding: 0 20px;
  }
  .filelist {
    /*width: 100%;*/
    padding: 10px 20px;
    .fileitem {
      display: flex;
      text-align: left;
      line-height: 25px;
      .name {
        color: #2f74ff;
        cursor: pointer;
      }
    }
  }
}
</style>
